import BizInput from '../../Mini/BizInput';
import { FormFieldComponentProps } from './fieldProps';

const TextField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	const inputType = (field.settings.type as string) ?? 'text';

	return (
		<>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
			<BizInput
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
				type={inputType}
				placeholder={field.placeholder}
				readonly={disabled}
			/>
		</>
	);
};

export default TextField;
